import { render, staticRenderFns } from "./password-reset.vue?vue&type=template&id=17e71156&scoped=true&"
import script from "./password-reset.vue?vue&type=script&lang=js&"
export * from "./password-reset.vue?vue&type=script&lang=js&"
import style0 from "./password-reset.vue?vue&type=style&index=0&id=17e71156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e71156",
  null
  
)

export default component.exports